export default __webpack_public_path__ + "static/media/4.c4d76d6a.png";